if (!customElements.get("m-localization-form")) {
  class MLocalizationForm extends HTMLElement {
    constructor() {
      super();

      const buttons = this.querySelectorAll('[data-lang]');

      buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          const value = e.currentTarget.dataset.lang;
          const form = button.closest('[data-localization-form]');
          const input = form?.querySelector('input[data-localization-input]');

          if (!form || !input || input.value === value) return;

          input.value = value;
          form.submit();
        });
      });
    }
  }

  customElements.define('m-localization-form', MLocalizationForm);
}
